import { render, staticRenderFns } from "./PainelSistema.vue?vue&type=template&id=185db466"
import script from "./PainelSistema.vue?vue&type=script&lang=ts"
export * from "./PainelSistema.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports